export default "/bundles/assets/location_efe8262a347ca8a35a55c8bb3dca03e8.png";